import { z, ZodType } from 'zod';
import { PlayerVoucherItem, playerVoucherItemSchema } from './player-voucher-item';

export type ActivatedPromocode = {
	id: number;
	name: string;
	balance: number;
	order: number;
	isConnected: boolean;
	voucherItem: PlayerVoucherItem;
};

export const activatedPromocodeSchema: ZodType<ActivatedPromocode> = z.object({
	id: z.number(),
	name: z.string(),
	balance: z.number(),
	order: z.number(),
	isConnected: z.boolean(),
	voucherItem: playerVoucherItemSchema,
});
